import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiWind, FiCoffee, FiMoon, FiDroplet } from 'react-icons/fi';

export default function Recovery() {
  const protocols = [
    { icon: FiWind, title: 'Breath Control', timing: 'Post-Load', status: 'Optimal' },
    { icon: FiDroplet, title: 'Hydration Cycle', timing: 'Continuous', status: 'Critical' },
    { icon: FiMoon, title: 'Sleep Hygiene', timing: 'Phase 0', status: 'Stable' },
    { icon: FiCoffee, title: 'Nutrient Timing', timing: 'Window Open', status: 'Ready' },
  ];

  return (
    <div className="glass-panel p-4">
      <h3 className="text-gray-400 text-xs font-mono mb-4 uppercase tracking-widest">System_Recovery.Nodes</h3>
      <div className="grid grid-cols-2 gap-3">
        {protocols.map((p, i) => (
          <div key={i} className="bg-carbon-900/50 border border-carbon-700 p-3 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon icon={p.icon} className="text-lime-500 text-sm" />
              <span className="text-xs text-white font-bold truncate">{p.title}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-[10px] text-gray-500 font-mono">{p.timing}</span>
              <span className={`text-[9px] font-mono px-1.5 py-0.5 rounded ${p.status === 'Critical' ? 'bg-red-500/10 text-red-400 border border-red-500/20' : 'bg-lime-500/10 text-lime-500 border border-lime-500/20'}`}>
                {p.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}